import { ArrowForward, DoubleArrow } from '@mui/icons-material'
import { Container, IconButton } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getSeminars } from '../../../../../redux/actions/seminars'
import { getSeminartypes } from '../../../../../redux/actions/seminartypes'
import { IRootState } from '../../../../../redux/types'
import SeminarInterface from '../../../../backoffice/seminars/models/Seminars'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import Header from '../../../../shared/components/Header'
import ScreenLoading from '../../../../shared/components/ScreenLoading'
import TypeFilter from '../../../../shared/components/TypeFilter'
import useSkeleton from '../../../../shared/components/layouts/SkeletonLayout'
import ContentFilter from '../../../../shared/components/layouts/filters/ContentFilter'
import useGeneralSummaryReport from '../../../../shared/hooks/useGeneralSummaryReport'
import HiddenDesktop from '../../../../shared/styles/HiddenDesktop'
import ScrollSubheader from '../../../../shared/styles/ScrollSubHeader'
import SubHeader from '../../../../shared/styles/Subheader'
import { IFilter } from '../../models/seminar'
import SeminarPanel from '../components/SeminarPanel'

function SeminarsHome() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { seminars, error, msg, loading } = useSelector((state: IRootState) => state.seminar)
  const { seminartypes } = useSelector((state: IRootState) => state.seminartype)
  const { globalFamilyId, globalBrandId, globalLineId, globalCountryId, globalLanguageId, globalOrderById } = useSelector(
    (state: IRootState) => state.global
  )

  const { loading: loadingSkeleton, component: componentSkeleton } = useSkeleton()
  useGeneralSummaryReport(8)

  const [filters, setFilters] = useState<IFilter>({
    seminartype_id: null,
    family_id: null,
    brand_id: null,
    line_id: null,
    country_id: null,
    language_id: null,
    orderby_id: null
  })

  useEffect(() => {
    if (seminartypes.length === 0)
      dispatch(
        getSeminartypes({
          language_id: globalLanguageId,
          country_id: globalCountryId
        })
      )
  }, [globalLanguageId, globalCountryId])

  useEffect(() => {
    setFilters({
      ...filters,
      seminartype_id: null,
      family_id: globalFamilyId,
      brand_id: globalBrandId,
      line_id: globalLineId,
      language_id: globalLanguageId,
      country_id: globalCountryId,
      orderby_id: globalOrderById
    })
  }, [globalFamilyId, globalBrandId, globalLineId, globalCountryId, globalLanguageId, globalOrderById])

  useEffect(() => {
    dispatch(getSeminars(filters))
  }, [filters])

  const handleChangeFilter = (seminartype_id: number) => {
    setFilters({ ...filters, seminartype_id })
  }

  const getSubsection = (): null | string => {
    let subsection = null
    if (filters.seminartype_id !== null && seminartypes.length > 0)
      subsection = seminartypes.find((seminartype: any) => seminartype.id === filters.seminartype_id).name

    return subsection
  }

  if (loadingSkeleton) {
    return <>{componentSkeleton}</>
  }

  const myElement: HTMLElement | null = document.getElementById('windowCourseClient')
  let midOfWidth = window.innerWidth / 2

  return (
    <>
      <Header title={t('seminars')} />
      <SubHeader>
        <ScrollSubheader id='windowCourseClient'>
          <TypeFilter
            id={null}
            type={t('all')}
            categories={[]}
            active={filters.seminartype_id === null}
            handleChangeFilter={handleChangeFilter}
          />
          {seminartypes.map((seminartype: any) => (
            <TypeFilter
              key={seminartype.id}
              id={seminartype.id}
              type={seminartype.name}
              categories={[]}
              active={seminartype.id === filters.seminartype_id}
              handleChangeFilter={handleChangeFilter}
            />
          ))}
          <ArrowForward />
        </ScrollSubheader>
        <HiddenDesktop>
          <IconButton
            sx={{ position: 'absolute !important', right: 0, top:'17%', zIndex: 10, backgroundColor: 'white' }}
            className="buttonScroll"
            onClick={() => {
              myElement?.scrollBy(midOfWidth, 0)
            }}
          >
              <DoubleArrow />
            </IconButton>
        </HiddenDesktop>
      </SubHeader>

      <ContentFilter showFilterBy={false} />

      <Container maxWidth="lg">
        <SeminarPanel
          highlightSeminars={seminars.filter((seminar: SeminarInterface) => seminar.highlight === 1)}
          seminars={seminars}
          loading={loading}
          subsection={getSubsection()}
        />
      </Container>

      <CustomSnackBar errors={[error]} msgs={[msg]} />
      <ScreenLoading loadings={[loading]} />
    </>
  )
}

export default SeminarsHome
